// extracted by mini-css-extract-plugin
export default {"singleFixtureCard":"SingleFixtureCard_singleFixtureCard__YPlTo"};